import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import AppRoutes from './components/AppRoutes';
import BookingLayout from './components/BookingLayout';
import { ReservationProvider } from './components/ReservationContext';

function LayoutRouter() {
  const location = useLocation();
  const bookingPages = ['/', '/room', '/contact', '/payment', '/confirmation'];
  const isBookingRoute = bookingPages.includes(location.pathname);

  // NOTE: Now state is moved into BookingLayout, so no need here
  // Just render BookingLayout with children

  if (isBookingRoute) {
    return (
      <BookingLayout>
        <AppRoutes />
      </BookingLayout>
    );
  }
  return <AppRoutes />;
}

function App() {
  return (
    <ReservationProvider>
      <Router>
        <Header />
        <LayoutRouter />
        <Footer />
      </Router>
    </ReservationProvider>
  );
}

export default App;
